import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../../utils/formatNumber'
import { ProductCategory } from '../../../types/modules/productCategory.type'
import UpdateCategoryForm from './UpdateCategoryForm'
import { PermissionGate } from '../../admin/PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    catgeory:ProductCategory
}

function CategoryItem({catgeory}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = catgeory.languages.find(s=>s.languageCode==="en")?.title ||"";
        const arName = catgeory.languages.find(s=>s.languageCode==="ar")?.title ||"";
  return (
    <>
    <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {formatNumber(catgeory.id)}
        </td>
     <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {arName}
        </td>

        <PermissionGate permissions={[PermissionsKey.UpdateStoreCategory]}>
            <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateCategoryForm
            defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        id={catgeory.id}
        onSubmitSuccess={() => {
            setIsOpen(p=>false);
  }}
        />
        </CustomModal>
    </>
  )
}

export default CategoryItem